import React from 'react'

const AgentNotification = () => {
  return (
    <div>AgentNotification</div>
  )
}

export default AgentNotification